import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { ScrollToTopOnNavigate } from "@/components/ScrollToTopOnNavigate";

// Eager load Index (homepage) for best LCP
import Index from "./pages/Index";

// Lazy load other pages to reduce initial bundle size
const NotFound = lazy(() => import("./pages/NotFound"));

// Marketing Pages
const SMM = lazy(() => import("./pages/marketing/SMM"));
const MarketResearch = lazy(() => import("./pages/marketing/MarketResearch"));

// Solutions Pages
const CRM = lazy(() => import("./pages/solutions/CRM"));
const Automation = lazy(() => import("./pages/solutions/Automation"));
const BIDashboards = lazy(() => import("./pages/solutions/BIDashboards"));
const CustomSolutions = lazy(() => import("./pages/solutions/CustomSolutions"));

// Loading fallback component
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
  </div>
);

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <ScrollToTopOnNavigate />
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/" element={<Index />} />
                
                {/* Marketing Routes */}
                <Route path="/marketing/smm" element={<SMM />} />
                <Route path="/marketing/research" element={<MarketResearch />} />
                
                {/* Solutions Routes */}
                <Route path="/solutions/crm" element={<CRM />} />
                <Route path="/solutions/automation" element={<Automation />} />
                <Route path="/solutions/bi-dashboards" element={<BIDashboards />} />
                <Route path="/solutions/custom" element={<CustomSolutions />} />
                
                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </BrowserRouter>
        </TooltipProvider>
      </LanguageProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;